import { combineReducers } from 'redux';

import companyPublicView from './companyPublicView.reducer';

export default combineReducers({
  companyPublicView: companyPublicView,
});
